import {
    NODE_WIDTH,
    WIDTH,
    HEIGHT,
    NODE_HEIGHT} from './constants.js';

export function getNonOverlapping(x, y, rack) {
    let count = 0;
    while (overlaps(x, y, rack) && count < 40) {
        x = (x + NODE_WIDTH);
        if (x >= (WIDTH - NODE_WIDTH)) {
            x = NODE_WIDTH;
            y = (y + NODE_HEIGHT + 20);
            if (y >= HEIGHT - NODE_HEIGHT) {
                y = NODE_HEIGHT + 40;
            }
        }
        count++;
    }
    return {x, y};
}

export function overlaps(x1, y1, rack) {
    for (let i in rack.effects) {
        let {x, y} = rack.effects[i];
        if (x1 >= x && y1 >= y &&
            x1 <= x + NODE_WIDTH &&
            y1 <= y + NODE_HEIGHT) {
            return true;
        }
        /*
        if (x1 <= x + NODE_WIDTH &&
            x1 >= x &&
            y >= y1 &&
            y <= y1 + NODE_HEIGHT) {
            return true;
        }
        */
    }
    return false;
}
